import '../css/Terms.css'
import {terms} from '../constants/Constants'

function Terms() {

    const displayTerms = (
        <ul className={"terms-list"}>
            {[...terms].map(term => (
                <li className={"term"} key={term}>{term}</li>
            ))}
        </ul>
    )

    return (
        <div className={"terms-body"}>
            <h1 className={"terms-heading"}>Terms</h1>
            <h2 className={"second-heading"}>Each player agrees that..</h2>
            {displayTerms}
        </div>
    )

}

export default Terms;